import '../utils/KeyboardEventsUtil';
import {ResolutionHandler} from '../utils/ResolutionHandler';
import {detect} from "detect-browser";
import {IS_CHINA} from "../utils/Environment";

export default class Controller {

  constructor() {
    // ResolutionHandler();
  }

  static getEnvComponentOrDefault(component){
    switch (component){
      case 'ChatComponent':
        return IS_CHINA?'ChatComponentChina':'ChatComponent';
      case 'StoreLocatorComponent':
        return IS_CHINA?'StoreLocatorComponentChina':'StoreLocatorComponent';
      case 'StoreLocatorDetailComponent':
        return IS_CHINA?'StoreLocatorDetailComponentChina':'StoreLocatorDetailComponent';
      case 'SearchGuestOrderComponent':
        return IS_CHINA?'SearchGuestOrderComponentChina':'SearchGuestOrderComponent';
      default:
        return component;
    }
  }

  /**
   * its used to add environmentally dependent components, but which should be included regardless of the controller loaded on the page
   */
  static applyEnvComponents(components=[]){

    if(IS_CHINA){
      components.push("LoginComponentChina");
      components.push("AskInvoiceComponent");
      components.push("PhoneNumberValidatorComponentChina");
      components.push("PhoneWithPrefixHandlerComponentChina");
      components.push("PreventCharPasteInNumberFieldsComponent");
    }

  }

  /**
   * its used to add components that should always be included regardless of the controller loaded on the page
   */
  static applyGlobalComponents(components=[]){

  }

  /**
   * Components that will be always initialized in every controller
   * @returns {string[]}
   * @constructor
   */
  static get BASE_COMPONENTS() {

    let components = [
      'HistoryManagerComponent',
      'TealiumLinkComponent',
      'RowTwinComponent',
      'MultilineEllipsisComponent',
      'TrackingComponent',
      'LoginComponent',
      'ContactUsComponent',
      'CookieComponent',
      'LoaderComponent',
      'MenuComponent',
      'FooterComponent',
      'ModalComponent',
      'DropdownComponent',
      'BurgerComponent',
      'SearchComponent',
      'BackdropComponent',
      'AddToCartComponent',
      'WishlistComponent',
      'MiniCartComponent',
      'ResetPwComponent',
      'SizesComponent',
      'AddToWishlistComponent',
      'StickyComponent',
      'CollapseComponent',
      'FixedMediaComponent',
      'SelectComponent',
      'BenefitBarComponent',
      'FormStylingComponent',
      'ChatComponent',
      'DatePickerComponent',
      'UpperCaseComponent'
    ];


    if(!IS_CHINA){
      components.push(
        'NewsletterComponent'
      );
    }

    components.push(
      'ShowPasswordComponent',
      'HeaderComponent',
      'DataShowComponent',
      'CarouselComponent',
      'TooltipCvvComponent',
      'TooltipComponent',
      'GlobalMessagesComponent',
      'FormValidationComponent',
      'DataLinkComponent',
      'NewPrivacyComponent',
      'NewPrivacyKoreaComponent',
      'PrivacyUnsubscribe',
      'TippyComponent',
      'SearchGuestOrderComponent',
      'RecommendationEngineComponent',
      'GoogleRecommendationEngineComponent',
      'PrivacyPreference',
      'SocialLoginComponent'
    );

    return components;
  }

  setBrowserAttributes(obj) {
    return new Promise((resolve, reject) => {
      try {
        for (let key of Object.keys(obj)) {
          document.documentElement.setAttribute(`data-browser-${key}`, obj[key]);
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Log utility
   * @param logStr
   */
  log(logStr = '') {
    if (logStr != '') {
      let myName = this.constructor.name;
      console.debug(`[${myName}] ${logStr}`);
    }
  }

  /*
   *  Initialization logic of the page
   */
  init() {
    this.log('Initializing..');
    // const browser = detect();
    if (detect()) this.setBrowserAttributes(detect()).then(res => { console.debug('Browser data saved') });

    ResolutionHandler();

    try {
      // Dynamic init of components related to a controller
      let componentsToRender = [...new Set(Controller.BASE_COMPONENTS.concat(this.constructor.COMPONENTS))].map(Controller.getEnvComponentOrDefault);

      //it is not the best idea, but it is possible to modify via "applyEnvComponents" the components specified as global
      Controller.applyGlobalComponents(componentsToRender);
      Controller.applyEnvComponents(componentsToRender);

      this.log(`Rendering ${componentsToRender}`);
      for (let component of componentsToRender) {
        import(/* webpackChunkName: `components-[request]` */ `../components/${component}`).then((module) => {
          let DynamicComponent = module.default; // we except that the component is the default attribute of the module
          // let dynamicComponent = new DynamicComponent();
          let htmlEl = document.querySelectorAll(`[data-js-component="${component}"]`);
          let dynamicComponent = new DynamicComponent(htmlEl);
          dynamicComponent.render();
        }).catch(error => {
          console.error(`Failed to load the component ${component}`,error);
          console.error(`Component ${component} load stacktrace`,error.stack);
        });
      }
    } catch (error) {
      console.error('Failed to iterate over controller\'s components', error.stack);
    }


  }
}
